
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M10.5 0C4.701 0 0 4.701 0 10.5S4.701 21 10.5 21 21 16.299 21 10.5A10.5 10.5 0 0010.5 0zm0 20.125a9.625 9.625 0 110-19.25 9.625 9.625 0 010 19.25z","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M7 10.938h3.063v.874a.437.437 0 10.874 0v-.874h.876a.437.437 0 100-.876h-.876V5.25a.437.437 0 10-.874 0v4.813H7a.437.437 0 100 .874zM10.281 15.75v.875a.219.219 0 10.438 0v-.875a.219.219 0 10-.438 0zM16.625 10.719a.219.219 0 100-.438h-.875a.219.219 0 100 .438h.875z"}}),_c('path',{attrs:{"d":"M10.5 2.188a.437.437 0 100 .874A7.438 7.438 0 113.062 10.5a.437.437 0 10-.874 0A8.312 8.312 0 1010.5 2.187z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/management/management.svg